import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SuccessFalureRoutingModule } from './success-falure-routing.module';
import { SuccessFalureComponent } from './success-falure.component';
import { SharedModule } from '../shared.module';


@NgModule({
  declarations: [
    SuccessFalureComponent
  ],
  imports: [
    CommonModule,
    SuccessFalureRoutingModule,
    SharedModule

  ],exports:[
    SuccessFalureComponent
  ]
})
export class SuccessFalureModule { }
